import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class NavigationHandlerService {
    router = inject(Router);
    // Track if user is currently within RequestQuoteComponent context
    private inRequestQuote$ = new BehaviorSubject<boolean>(false);
    // Emit when the header logo is clicked
    private logoClickSubject = new Subject<void>();

    logoClick$ = this.logoClickSubject.asObservable();
    isInRequestQuote$ = this.inRequestQuote$.asObservable();

    setInRequestQuote(inFlow: boolean): void {
        this.inRequestQuote$.next(inFlow);
    }

    isInRequestQuote(): boolean {
        return this.inRequestQuote$.getValue();
    }

    emitLogoClick(): void {
        this.logoClickSubject.next();
    }

    navigateToRoute(path: string): void {
        const { basePath, id } = this.splitPathAndId(path);
    
        // Navigate using the base path and dynamic ID
        if (id) {
          this.router.navigate([basePath, id]);
        } else {
          this.router.navigate([basePath]);
        }
    }

    // Function to split the path and extract dynamic ID
    splitPathAndId(path: string) {
        const segments = path.split('/').filter(segment => segment); // Split path into segments
        const id = segments.pop(); // Get the last segment (assumed to be the ID)

        // Return the base path (all segments except the last one) and the dynamic ID
        const basePath = segments.join('/');
        
        return {
        basePath,
        id
        };
    }
}